const PLURAL_ES_SUFFIX_PATTERN = /(?:s|x|z|ch|sh)$/i
const CONSONANT_Y_SUFFIX_PATTERN = /[^aeiou]y$/i

/**
 * Applies basic English plural suffix rules. Does not handle irregular nouns —
 * pass an explicit plural to `pluralize` when needed (e.g. `'child'`, `'children'`).
 */
export function plural(word: string): string {
  if (word.length === 0) {
    return word
  }

  if (PLURAL_ES_SUFFIX_PATTERN.test(word)) {
    return `${word}es`
  }

  if (CONSONANT_Y_SUFFIX_PATTERN.test(word)) {
    return `${word.slice(0, -1)}ies`
  }

  return `${word}s`
}

/**
 * Returns the singular or plural form of a word based on count.
 *
 * @example
 * pluralize(1, 'order') // 'order'
 * pluralize(2, 'order') // 'orders'
 * pluralize(2, 'child', 'children') // 'children'
 */
export function pluralize(
  count: number,
  singular: string,
  explicitPlural?: string,
): string {
  if (count === 1) {
    return singular
  }

  return explicitPlural ?? plural(singular)
}
